import { IMPORT_SAVE_CSV_FILE_DATA } from './constants';
export function saveCsvFileData(args = {}) {
  return {
    type: IMPORT_SAVE_CSV_FILE_DATA,
    csvData: args.data,
    csvHeader: args.fields,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case IMPORT_SAVE_CSV_FILE_DATA:
      return {
        ...state,
        csvData: action.csvData,
        csvHeader: action.csvHeader,
      };

    default:
      return state;
  }
}
